<template lang="pug">
  .datepicker
    VueCtkDateTimePicker(no-label v-model="local_date" formatted="llll" @input="$emit('input', local_date)")
</template>

<script>
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
  import moment from 'moment';

  export default {
    data: function() {
      return {
        local_date: null,
        date: null
      }
    },
    methods: {
      now: function( thisDate ) {
        if(thisDate !== undefined && thisDate != null)
          return moment(thisDate).format(this.date_format);

        return moment().format(this.date_format);
      },
    },
    components: {
      VueCtkDateTimePicker,
    },
    created: function() {
      this.local_date = this.now(this.date);
    }
  }
</script>

<style lang="scss">
  .datepicker {
    .field-input {
      height:52px;
      border-radius:0px;
      padding-left:0px;
      border:0px none;
      background-color: #f3f3f3;
    }
    .custom-button.round {
      background:none;
      margin-top:6px;
    }
  }
</style>